import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2";
import "../ModalHistoricoStatus/ModalHistoricoStatus.css";
import TabelaV2 from "../TabelaV2/TabelaV2";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao?: string;
	tituloConfirmar: string;
	texto?: string;
	dataAlteracao?: string;
	open: boolean;
	onClose: () => void;
	valoresHistorico: any;
	colunas: any;
}

function ModalHistoricoStatus(props: SimpleDialogProps) {
	const { onClose, open } = props;

	const handleClose = () => {
		onClose();
	};

	const handleClick = () => {
		onClose();
	};

	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<div className="div-modal-usuario">
					<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
					<DialogContent>
						<TabelaV2
							classeSelecionado="data"
							nomeClasse1="outer-wrapper"
							nomeClasse2="table-wrapper-v2"
							colunas={props.colunas}
							dados={props.valoresHistorico}
							nome="status"
						/>
					</DialogContent>
					<DialogActions>
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							titulo="OK"
							cor="#0946B8"
							onClick={handleClick}
						/>
					</DialogActions>
				</div>
			</Dialog>
		</div>
	);
}

export default ModalHistoricoStatus;
